import React, { Component } from "react";
import { connect } from "react-redux";
import { docPermConstants } from "../../../../_constants/permissionConstants";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import AlertModal from "../../../_common/AlertModal";
import keywordActions from "../../../../_actions/keywordActions";

class ProjSetupCcoDetails extends Component {
  state = {
    showAlert_delKwConfirm: false,
  };

  handleClick_delKeyword = (e) => {
    e.preventDefault();
    this.toggleAlert_delKwConfirm();
  };

  toggleAlert_delKwConfirm = () =>
    this.setState({ showAlert_delKwConfirm: !this.state.showAlert_delKwConfirm });

  handleAlert_delKwConfirm = (action) => async () => {
    const { dispatch, keywordId, projectId, deleteCallback } = this.props;
    if (action === "accept") {
      await dispatch(keywordActions.deleteKeyword(keywordId, projectId));
      deleteCallback && deleteCallback();
    }
    this.toggleAlert_delKwConfirm();
  };

  render() {
    const { showAlert_delKwConfirm } = this.state;
    const {
      keywordDetails: keyword,
      handleClick_editKeyword,
      permissions,
      fetching,
    } = this.props;
    return (
      <React.Fragment>
        {keyword ? (
          <h3 className="card-title mx-0">{"Keyword Tag: " + keyword.keywordTag}</h3>
        ) : fetching ? (
          <h5 className="text-muted">Loading...</h5>
        ) : (
          <h5 className="text-muted">No keyword selected</h5>
        )}
        {keyword && (
          <React.Fragment>
            <div className="row mx-0 pl-0">
              <div className="col pl-0">
                <ul className="list-group-flush border-bottom border-top mb-2 pl-0">
                  <li className="list-group-item py-1 pl-1">
                    <div className="row">
                      <div className="col pr-1">
                        <b>Description:</b>
                      </div>
                      <div className="col pl-1">{keyword.description || "(N/A)"}</div>
                    </div>
                  </li>
                  <li className="list-group-item py-1 pl-1">
                    <div className="row">
                      <div className="col pr-1">
                        <b>Default:</b>
                      </div>
                      <div className="col pl-1">{keyword.isDefault ? "Yes" : "No"}</div>
                    </div>
                  </li>
                  <li className="list-group-item py-1 pl-1">
                    <div className="row">
                      <div className="col pr-1">
                        <b>Created By:</b>
                      </div>
                      <div className="col pl-1">{keyword.createdByUserId}</div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div className="form-row form-group">
              <button
                type="button"
                name="editKeywordDetails"
                id="editKeywordDetails"
                className="btn btn-secondary mr-2"
                onClick={handleClick_editKeyword}
                disabled={!permissions.includes(docPermConstants.EDIT_LEVEL_2)}
              >
                Edit...
              </button>
              <button
                type="button"
                name="delKeyword"
                id="delKeyword"
                className="btn btn-danger mr-2"
                onClick={this.handleClick_delKeyword}
                disabled={
                  keyword.isDefault ||
                  !permissions.includes(docPermConstants.EDIT_LEVEL_2) ||
                  keyword.hasLinks
                }
              >
                Delete
              </button>
              {!keyword.isDefault && keyword.hasLinks && (
                <button
                  type="button"
                  name="kwInUse"
                  id="kwInUse"
                  className="btn btn-link text-muted p-1"
                  onClick={() => {}}
                >
                  <FontAwesomeIcon icon="lock" className="fa-fw mr-1" />
                  In Use
                </button>
              )}
              {keyword.isDefault && (
                <React.Fragment>
                  <span className="text-muted">
                    <FontAwesomeIcon icon="lock" className="fa-fw mr-1" />
                    Default
                  </span>
                </React.Fragment>
              )}
            </div>
          </React.Fragment>
        )}
        {showAlert_delKwConfirm && (
          <AlertModal
            alertTitle="Confirm Delete"
            alertTitleClass="bg-danger text-white"
            alertTitleIcon="exclamation-triangle"
            alertText="Are you sure you want to delete this keyword?"
            acceptCaption="Yes"
            acceptClass="danger"
            provideReject={true}
            rejectCaption="No"
            rejectClass="secondary"
            handleAlertAction={this.handleAlert_delKwConfirm}
            showAlertModal={showAlert_delKwConfirm}
            toggleAlertModal={this.toggleAlert_delKwConfirm}
          />
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  fetching: state.keywords.fetching,
  keywordDetails: state.keywords.openKeywordDetails[ownProps.projectId]
    ? state.keywords.openKeywordDetails[ownProps.projectId][ownProps.keywordId] || null
    : null,
});

export default connect(mapStateToProps)(ProjSetupCcoDetails);
